<template>
  <div class="mod-commission-rule">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.ruleName" :placeholder="$t('commission.ruleName')" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.ruleType" :placeholder="$t('commission.ruleType')" clearable>
          <el-option :label="$t('commission.product')" value="PRODUCT"></el-option>
          <el-option :label="$t('commission.category')" value="CATEGORY"></el-option>
          <el-option :label="$t('commission.store')" value="STORE"></el-option>
          <el-option :label="$t('commission.role')" value="ROLE"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.commissionType" :placeholder="$t('commission.commissionType')" clearable>
          <el-option :label="$t('commission.percentage')" value="PERCENTAGE"></el-option>
          <el-option :label="$t('commission.fixed')" value="FIXED"></el-option>
          <el-option :label="$t('commission.tiered')" value="TIERED"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.isActive" :placeholder="$t('common.status')" clearable>
          <el-option :label="$t('common.enabled')" :value="1"></el-option>
          <el-option :label="$t('common.disabled')" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">{{ $t('common.query') }}</el-button>
        <el-button type="primary" @click="addOrUpdateHandle()">{{ $t('common.add') }}</el-button>
        <el-button type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0">{{ $t('common.batchDelete') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;">
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50">
      </el-table-column>
      <el-table-column
        prop="id"
        header-align="center"
        align="center"
        label="ID">
      </el-table-column>
      <el-table-column
        prop="ruleName"
        header-align="center"
        align="center"
        :label="$t('commission.ruleName')">
      </el-table-column>
      <el-table-column
        prop="ruleType"
        header-align="center"
        align="center"
        :label="$t('commission.ruleType')">
        <template slot-scope="scope">
          <el-tag :type="getRuleTypeTag(scope.row.ruleType)">
            {{ getRuleTypeText(scope.row.ruleType) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="targetName"
        header-align="center"
        align="center"
        :label="$t('commission.targetName')">
      </el-table-column>
      <el-table-column
        prop="commissionType"
        header-align="center"
        align="center"
        :label="$t('commission.commissionType')">
        <template slot-scope="scope">
          <el-tag :type="getCommissionTypeTag(scope.row.commissionType)">
            {{ getCommissionTypeText(scope.row.commissionType) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="commissionValue"
        header-align="center"
        align="center"
        :label="$t('commission.commissionValue')">
        <template slot-scope="scope">
          {{ scope.row.commissionValue }}{{ scope.row.commissionType === 'PERCENTAGE' ? '%' : '元' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="priority"
        header-align="center"
        align="center"
        :label="$t('commission.priority')">
      </el-table-column>
      <el-table-column
        prop="isActive"
        header-align="center"
        align="center"
        :label="$t('common.status')">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isActive === 1 ? 'success' : 'danger'">
            {{ scope.row.isActive === 1 ? $t('common.enabled') : $t('common.disabled') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="startTime"
        header-align="center"
        align="center"
        :label="$t('commission.startTime')">
        <template slot-scope="scope">
          {{ scope.row.startTime | dateFormat }}
        </template>
      </el-table-column>
      <el-table-column
        prop="endTime"
        header-align="center"
        align="center"
        :label="$t('commission.endTime')">
        <template slot-scope="scope">
          {{ scope.row.endTime | dateFormat }}
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        :label="$t('common.createTime')">
        <template slot-scope="scope">
          {{ scope.row.createTime | dateFormat }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        :label="$t('common.operation')">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('common.edit') }}</el-button>
          <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('common.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
  import AddOrUpdate from './rule-add-or-update'
  export default {
    data () {
      return {
        dataForm: {
          ruleName: '',
          ruleType: '',
          commissionType: '',
          isActive: ''
        },
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: [],
        addOrUpdateVisible: false
      }
    },
    components: {
      AddOrUpdate
    },
    created () {
      this.getDataList()
    },
    activated () {
      this.getDataList()
    },
    methods: {
      // 获取数据列表
      getDataList () {
        this.dataListLoading = true
        this.$http({
          url: 'commission/rule/page',
          method: 'get',
          params: {
            'page': this.pageIndex,
            'limit': this.pageSize,
            'ruleName': this.dataForm.ruleName,
            'ruleType': this.dataForm.ruleType,
            'commissionType': this.dataForm.commissionType,
            'isActive': this.dataForm.isActive
          }
        }).then(({data}) => {
          console.log('Commission rule response:', data)
          if (data && data.code === 0) {
            this.dataList = data.data.list || []
            this.totalPage = data.data.total || 0
            console.log('Loaded commission rules:', this.dataList.length)
          } else {
            console.log('No data or error:', data)
            this.dataList = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        }).catch(error => {
          console.error('Commission rule error:', error)
          this.dataList = []
          this.totalPage = 0
          this.dataListLoading = false
        })
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 多选
      selectionChangeHandle (val) {
        this.dataListSelections = val
      },
      // 新增 / 修改
      addOrUpdateHandle (id) {
        this.addOrUpdateVisible = true
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init(id)
        })
      },
      // 删除
      deleteHandle (id) {
        var ids = id ? [id] : this.dataListSelections.map(item => {
          return item.id
        })
        this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            url: 'commission/rule/delete',
            method: 'post',
            data: ids
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        })
      },
      // 获取规则类型标签
      getRuleTypeTag (type) {
        const tagMap = {
          'PRODUCT': 'success',
          'CATEGORY': 'primary',
          'STORE': 'warning',
          'ROLE': 'info'
        }
        return tagMap[type] || 'info'
      },
      // 获取规则类型文本
      getRuleTypeText (type) {
        const textMap = {
          'PRODUCT': '产品',
          'CATEGORY': '分类',
          'STORE': '门店',
          'ROLE': '角色'
        }
        return textMap[type] || type
      },
      // 获取提成类型标签
      getCommissionTypeTag (type) {
        const tagMap = {
          'PERCENTAGE': 'success',
          'FIXED': 'primary',
          'TIERED': 'warning'
        }
        return tagMap[type] || 'info'
      },
      // 获取提成类型文本
      getCommissionTypeText (type) {
        const textMap = {
          'PERCENTAGE': '比例',
          'FIXED': '固定',
          'TIERED': '阶梯'
        }
        return textMap[type] || type
      }
    }
  }
</script>
